<template>
  <div class="crm">
    <div class="selectBox">
      <el-form :inline="true" :model="dataForm" ref="lineForm">
        <el-form-item label="客户选择">
          <el-select
            v-model="playCompanyId"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in dataList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
              style="width: 200px"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="okcc" :loading="getplayCustomLoading"
            >切换客户</el-button
          >
        </el-form-item>
        <!-- <el-form-item label="当前操作客户:">
          {{ playCompanyId || "请选择" }}
        </el-form-item> -->
      </el-form>
    </div>
    <div class="if">
      <If v-if="playUrl" :playUrl="playUrl" :key="playUrl" />
      <!-- <div v-if="playUrl" id="activity"></div> -->
      <div v-else style="margin: 100px">
        <el-empty description="请选择CRM客户"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import If from "./if.vue";
import TenantCustomersSelectVue from "@/components/TenantCustomersSelect.vue";
export default {
  mixins: [viewModule],
  components: {
    TenantCustomersSelectVue,
    If,
  },
  props: {
    path: {
      type: String,
      default: "/login",
    },
  },
  mounted() {
    if (this.$store.state.playCompanyId) {
      this.playCompanyId = this.$store.state.playCompanyId;
      this.okcc();
    }
  },
  data() {
    return {
      // crmUrl: "http://localhost:8081/#",
      crmUrl: "https://crm.situ123.com/#",
      mixinViewModuleOptions: {
        requestMethod: "get",
        getDataListIsPage: true,
        getDataListURL: "/api/Common/Get",
      },
      getplayCustomLoading: false,
      playCompanyId: "",
      playUrl: "",
      limit: 1000
    };
  },
  methods: {
    okcc() {
      if (!this.playCompanyId) return this.$message.error("请选择要操作的客户");
      this.getplayCustomLoading = true;
      this.$http({
        url: "/api/CRM/User?companyId=" + this.playCompanyId,
        method: "get",
      })
        .then((res) => {
          console.log(res);
          if (!res.data.response.Token) {
            return this.$message.error("当前客户未设置crm帐号");
          }
          this.playUrl =
            this.crmUrl +
            this.path +
            "?" +
            `u=${res.data.response.UserName}&p=${res.data.response.Token}`;
          //   this.playUrl = this.crmUrl
          this.$store.commit("setPlayCompanyId", this.playCompanyId);
        })
        .finally(() => (this.getplayCustomLoading = false));
      //   this.playUrl =
      //     this.crmUrl + "u=13249711383&p=a4d352382aa63f3d8c542b9d2e2f9f5f";
      //   //   this.playUrl = this.crmUrl
    },
  },
};
</script>

<style scoped>
.crm {
  height: 100%;
}
.selectBox {
  min-height: 60px;
}
.if {
  width: 100%;
  height: calc(100% - 60px);
}
</style>